import guestEn from "./guest.en";

const guestLv: Record<string, string> = {
  ...guestEn,
  "guest.header.venueFallback": "Vieta",
  "guest.header.help": "Palīdzība",
  "guest.language.label": "Valoda",
  "guest.legal.terms": "Noteikumi",
  "guest.legal.privacy": "Privātuma politika",
  "guest.help.title": "Palīdzība",
  "guest.help.body": "Mēs esam paziņojuši viesmīlim. Ja palīdzība joprojām nepieciešama, aizveriet šo ziņu un informējiet viņu.",
  "guest.tabs.payment": "Maksāt",
  "guest.tabs.newPurchases": "Jauni",
  "guest.selection.title": "Ko maksāt",
  "guest.selection.subtitle": "Izvēlies rēķinus",
  "guest.selection.selectAll": "Visi",
  "guest.selection.clear": "Notīrīt",
  "guest.selection.emptyOrders": "Šeit būs jūsu rēķini",
  "guest.selection.notPayable": "Neviens rēķins nav apmaksājams",
  "guest.intent.title": "Izvēlies darbību",
  "guest.intent.addPositions": "Pievienot pozīcijas",
  "guest.intent.payAllPositions": "Apmaksāt visu galdu",
  "guest.intent.payMyPositions": "Apmaksāt manas pozīcijas",
  "guest.intent.selectMyItemsTitle": "Izvēlies manas pozīcijas",
  "guest.intent.selectAllInOrder": "Izvēlēties visu: {orderLabel}",
  "guest.intent.clearSelection": "Notīrīt",
  "guest.intent.paySelectedItems": "Apmaksāt izvēlētās pozīcijas",
  "guest.intent.selectMyItemsEmpty": "Pagaidām nav pieejamu pozīciju izvēlei.",
  "guest.intent.itemsUnavailableReason": "Atvērtā pasūtījuma pozīcijas īslaicīgi nav pieejamas. Pirms pozīciju apmaksas palūdziet viesmīlim atjaunot galdu.",
  "guest.intent.callWaiter": "Pasaukt viesmīli",
  "guest.intent.leaveTip": "Atstāt dzeramnaudu",
  "guest.preorders.refresh": "Atjaunot",
  "guest.preorders.course": "Pasniegšanas kartība {course}",
  "guest.unified.queue.title": "Grozs",
  "guest.stepper.select": "Izvēle",
  "guest.stepper.amount": "Summa",
  "guest.stepper.tip": "Dzeramnauda",
  "guest.stepper.pay": "Maksāt",
  "guest.stepper.done": "Gatavs",
  "guest.common.back": "Atpakaļ",
  "guest.common.or": "vai",
  "guest.status.open": "Atvērts",
  "guest.status.closed": "Aizvērts",
  "guest.order.openedAt": "Atvērts {time}",
  "guest.order.paid": "Samaksāts",
  "guest.order.remaining": "Atlikums",
  "guest.order.itemsLabel": "vien.",
  "guest.order.hideFullList": "Slēpt",
  "guest.order.moreItems": "+{count} vēl",
  "guest.order.notPayable": "Neapmaksājams",
  "guest.order.leaveTip": "Atstāt dzeramnaudu",
  "guest.postVisitTip.notice": "Jūs atstājat dzeramnaudu pēc vizītes rēķinam {orderLabel}.",
  "guest.postVisitTip.min": "Minimālā dzeramnauda ar karti ir 1.00 {currency}.",
  "guest.footer.orderedTotal": "Pasūtīts",
  "guest.footer.inCart": "Grozā",
  "guest.footer.cartTotal": "Groza summa",
  "guest.footer.selected": "Atlasīts",
  "guest.footer.payingNow": "Tagad",
  "guest.footer.payer": "Maksātājs",
  "guest.footer.remainingAfter": "Paliks",
  "guest.checkout.reconcile.updatedSelection": "Sastāvs atjaunināts. Apmaksai pieejami tikai aktuālie pasūtījumi.",
  "guest.checkout.reconcile.continue": "Turpināt",
  "guest.footer.tip": "Dzeramnauda",
  "guest.footer.total": "Kopā",
  "guest.payment.cta.continue": "Turpināt",
  "guest.payment.cta.chooseAmount": "Izvēlēties summu",
  "guest.payment.cta.continueToTip": "Uz dzer.",
  "guest.payment.cta.continueToPay": "Uz maksu",
  "guest.payment.cta.emptyCartAndPay": "Maksāt",
  "guest.feedback.header": "Kā mūs atradi?",
  "guest.feedback.body.lovedIt": "Patika? Novērtējiet mūs.",
  "guest.feedback.body.improve": "Var labāk? Uzrakstiet privāti.",
  "guest.feedback.cta.publicReview": "Ļoti patika ⭐⭐⭐⭐⭐",
  "guest.feedback.cta.privateFeedback": "Pastāsti privāti",
  "guest.feedback.socialProof": "{count}+ viesi mūs novērtēja ar 5★",
  "guest.feedback.source.question": "Kā mūs atradi?",
  "guest.feedback.source.google": "Google",
  "guest.feedback.source.instagram": "Instagram",
  "guest.feedback.source.tiktok": "TikTok",
  "guest.feedback.source.tripadvisor": "TripAdvisor",
  "guest.feedback.source.friends": "Draugi",
  "guest.feedback.source.returning": "Jau biju",
  "guest.feedback.source.press": "Prese",
  "guest.feedback.source.walkedBy": "Garām ejot",
  "guest.feedback.destination.choose": "Kur vēlies atstāt atsauksmi?",
  "guest.feedback.secondary.title": "Vēl vietas, kur mūs novērtēt",
  "guest.feedback.private.helper": "Atvērs e-pasta lietotni ar iepriekš aizpildītu ziņu.",
  "guest.feedback.destination.email": "E-pasts",
  "guest.feedback.destination.review": "Atsauksme",
  "guest.feedback.visitType.label": "Vai jūs pie mums esat bijis iepriekš?",
  "guest.feedback.visitType.firstTime": "Pirmo reizi",
  "guest.feedback.visitType.returning": "Jau biju",
  "guest.payment.cta.done": "Izlaist",
  "guest.payment.cta.another": "Pievienot maksājumu",
  "guest.order.whose": "Kura pasūtījums?",
  "guest.order.guestName": "Viesis: {name}",
  "guest.order.newOrder": "Jauns pasūtījums",
  "guest.order.nameModal.title": "Kura pasūtījums?",
  "guest.order.nameModal.placeholder": "Nav obligāti",
  "guest.common.cancel": "Atcelt",
  "guest.common.clear": "Notīrīt",
  "guest.common.save": "Saglabāt",
  "guest.common.close": "Aizvērt",
  "guest.common.options": "Opcijas",
  "guest.cart.inclOptions": "(iekļautas opcijas)",
  "guest.scheduledVisit.success.title": "Iepriekšpasūtījums apmaksāts",
  "guest.scheduledVisit.success.body": "Maksājums pabeigts. Iepriekšpasūtījums ir apstrādē.",
  "guest.scheduledVisit.success.addItems": "Pievienot vēl ēdienus",
  "guest.scheduledVisit.success.back": "Atpakaļ pie galda",
  "guest.scheduledVisit.success.reservationNumber": "Rezervācijas Nr.",
  "guest.scheduledVisit.success.date": "Datums",
  "guest.scheduledVisit.success.time": "Laiks",
  "guest.scheduledVisit.success.place": "Galds",
  "guest.scheduledVisit.success.waitlist": "Gaidīšanas saraksts (galds vēl nav piešķirts)",
  "guest.scheduledVisit.success.guestName": "Viesa vārds",
  "guest.scheduledVisit.success.preorderItems": "Iepriekšpasūtījuma pozīcijas",
  "guest.scheduledVisit.success.course": "Pasniegšanas kartība {course}",
  "guest.scheduledVisit.success.subtotal": "Kopsumma",
  "guest.scheduledVisit.success.paid": "Apmaksāts",
  "guest.scheduledVisit.success.remaining": "Atlikums",
  "guest.scheduledUnified.common.loading": "Ielādē ieplānoto vizīti…",
  "guest.scheduledUnified.common.back": "Atpakaļ",
  "guest.scheduledUnified.common.continue": "Turpināt",
  "guest.scheduledUnified.visit.title": "Ieplānotā vizīte",
  "guest.scheduledUnified.visit.dateLabel": "Datums",
  "guest.scheduledUnified.visit.guestsLabel": "Viesi",
  "guest.scheduledUnified.visit.durationLabel": "Ilgums (min)",
  "guest.scheduledUnified.visit.availableTimeLabel": "Pieejamie laiki",
  "guest.scheduledUnified.visit.noSlots": "Izvēlētajam datumam nav pieejamu laiku.",
  "guest.scheduledUnified.visit.noTableAssigned": "Galds vēl nav piešķirts. Viesmīlis piešķirs galdu pirms piekļuves priekšpasūtījumam.",
  "guest.scheduledUnified.cart.title": "Grozs",
  "guest.scheduledUnified.cart.stepHint": "Groza solis ir gatavs. Pozīcijas varēsiet pievienot pēc rezervācijas apstiprināšanas.",
  "guest.scheduledUnified.cart.existingCount": "Esošie lokālie grozi: {count}",
  "guest.scheduledUnified.cart.empty": "Pagaidām nav pozīciju.",
  "guest.scheduledUnified.cart.preorderTitle": "Priekšpasūtījuma grozs",
  "guest.scheduledUnified.cart.summary": "{count} pozīcijas • {total}",
  "guest.scheduledUnified.cart.chooseProduct": "Izvēlēties produktu",
  "guest.scheduledUnified.cart.course": "Pasniegšanas kartība {value}",
  "guest.scheduledUnified.cart.remove": "Dzēst",
  "guest.scheduledUnified.cart.edit": "Labot",
  "guest.scheduledUnified.cart.menuTitle": "Ēdienkarte",
  "guest.scheduledUnified.cart.menuSubtitle": "Izvēlieties pozīcijas priekšpasūtījumam",
  "guest.scheduledUnified.cart.menuSearchPlaceholder": "Meklēt ēdienus",
  "guest.scheduledUnified.cart.menuEmpty": "Nekas nav atrasts",
  "guest.scheduledUnified.cart.menuInCart": "Grozā: {count}",
  "guest.scheduledUnified.cart.addItem": "Pievienot pozīciju",
  "guest.scheduledUnified.cart.itemFallback": "Pozīcija",
  "guest.scheduledUnified.cart.dialogDescription": "Pielāgojiet pozīciju pirms pievienošanas grozam.",
  "guest.scheduledUnified.cart.quantityLabel": "Daudzums",
  "guest.scheduledUnified.cart.courseLabel": "Pasniegšanas kartība",
  "guest.scheduledUnified.cart.commentLabel": "Komentārs",
  "guest.scheduledUnified.cart.commentPlaceholder": "Komentārs virtuvei / viesmīlim",
  "guest.scheduledUnified.cart.cancel": "Atcelt",
  "guest.scheduledUnified.cart.updateItem": "Atjaunināt pozīciju",
  "guest.scheduledUnified.cart.addToCart": "Pievienot grozam",
  "guest.scheduledUnified.review.title": "Pārskats",
  "guest.scheduledUnified.review.cta.bookAndPay": "Rezervēt un samaksāt",
  "guest.scheduledUnified.review.date": "Datums: {value}",
  "guest.scheduledUnified.review.time": "Laiks: {value}",
  "guest.scheduledUnified.review.guests": "Viesi: {value}",
  "guest.scheduledUnified.review.duration": "Ilgums: {value} min",
  "guest.scheduledUnified.review.guestNameLabel": "Vārds",
  "guest.scheduledUnified.review.guestNamePlaceholder": "Jūsu vārds",
  "guest.scheduledUnified.review.guestEmailLabel": "Email",
  "guest.scheduledUnified.review.guestEmailPlaceholder": "you@example.com",
  "guest.scheduledUnified.review.guestPhoneLabel": "Tālrunis",
  "guest.scheduledUnified.review.guestPhonePlaceholder": "+371...",
  "guest.scheduledUnified.review.termsPrefix": "Es piekrītu",
  "guest.scheduledUnified.review.termsLink": "lietošanas noteikumiem",
  "guest.scheduledUnified.review.privacyLink": "privātuma politikai",
  "guest.scheduledUnified.review.publicOfferLink": "publiskajam piedāvājumam",
  "guest.scheduledUnified.review.andWord": "un",
  "guest.scheduledUnified.review.personalDataPrefix": "Es piekrītu",
  "guest.scheduledUnified.review.personalDataLink": "personas datu apstrādei",
  "guest.scheduledUnified.waitlist.prompt": "Nav brīvu galdu. Pievienoties gaidīšanas sarakstam?",
  "guest.scheduledUnified.waitlist.join": "Pievienoties gaidīšanas sarakstam",
  "guest.scheduledUnified.waitlist.changeTime": "Mainīt laiku",
  "guest.scheduledUnified.waitlist.created": "Gaidīšanas saraksta pieteikums izveidots.",
  "guest.scheduledUnified.featured.title": "Ieteikumi",
  "guest.scheduledUnified.featured.priceOnRequest": "Cena pēc pieprasījuma",
  "guest.scheduledUnified.result.successTitle": "Rezervācija un priekšpasūtījums apstiprināti",
  "guest.scheduledUnified.result.failureTitle": "Maksājumu neizdevās pabeigt",
  "guest.scheduledUnified.result.failureBody": "Rezervāciju neizdevās pabeigt. Lūdzu, mēģiniet vēlreiz.",
  "guest.scheduledUnified.failure.code": "Kļūdas kods: {value}",
  "guest.scheduledUnified.failure.noChargeHint": "Ja banka parādīja rezervētu summu, tā tiks atbrīvota automātiski pēc bankas noteikumiem.",
  "guest.scheduledUnified.failure.changeTime": "Izvēlēties citu laiku",
  "guest.scheduledUnified.failure.retry": "Mēģināt vēlreiz",
  "guest.scheduledUnified.steps.visit": "Vizīte",
  "guest.scheduledUnified.steps.cart": "Grozs",
  "guest.scheduledUnified.steps.review": "Pārskats",
  "guest.scheduledUnified.errors.merchantMissing": "Widget URL trūkst merchant parametra.",
  "guest.scheduledUnified.errors.invalidGuestName": "Vārds ir obligāts.",
  "guest.scheduledUnified.errors.invalidGuestEmail": "Ievadiet derīgu email.",
  "guest.scheduledUnified.errors.invalidGuestPhone": "Ievadiet derīgu tālruņa numuru.",
  "guest.scheduledUnified.errors.selectTimeRequired": "Vispirms izvēlieties vizītes laiku.",
  "guest.scheduledUnified.errors.selectDishRequired": "Piepildiet grozu ar visu nepieciešamo, lai varam sagatavot pasūtījumu līdz jūsu vizītes laikam.",
  "guest.scheduledUnified.errors.termsNotAccepted": "Lai turpinātu, piekrītiet noteikumiem, privātuma politikai un publiskajam piedāvājumam.",
  "guest.scheduledUnified.errors.personalDataConsentRequired": "Nepieciešama piekrišana personas datu apstrādei.",
  "guest.errors.productStopped": "Dažas pozīcijas vairs nav pieejamas. Atjaunojiet ēdienkarti un izņemiet nepieejamās pozīcijas no groza.",
  "guest.loyalty.collapsible.prompt": "Vai jums ir lojalitātes karte?",
  "guest.loyalty.collapsible.selected": "Lojalitāte: {mask}",
};

export default guestLv;
